import Image from "next/image";
import { Link } from "@/i18n/navigation";
import React from "react";

import { HeaderClient } from "./client";
import { LanguageSwitcher } from "@/components/language-switcher";
import { isBillingEnabled } from "@/lib/billing";

interface NavLink {
	external?: boolean;
	href: string;
	label: string;
}

export const PRIMARY_LINKS: NavLink[] = [
	{ href: "/", label: "nav.home" },
	{ href: "/#features", label: "nav.features" },
	{ href: "/feedback", label: "nav.feedback" },
	{ href: "/#pricing", label: "nav.pricing" },
	{ href: "/changelog", label: "nav.changelog" },
	{ href: "https://docs.projme.ru", label: "nav.docs", external: true },
];

const AppLogo = React.memo(function AppLogo() {
	return (
		<Link
			aria-label="forms.projme home"
			className="flex items-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
			href="/"
		>
			<Image
				alt=""
				className="size-8"
				height={32}
				src="/android-chrome-192x192.png"
				width={32}
			/>
			<span className="font-semibold text-2xl tracking-tight">forms.projme</span>
		</Link>
	);
});

AppLogo.displayName = "AppLogo";

export default function Header() {
	return (
		<nav
			aria-label="Primary navigation"
			className="mx-auto mt-12 flex w-full max-w-7xl items-center justify-between gap-8 font-inter text-sm"
		>
			<a
				className="sr-only rounded-md bg-background px-3 py-2 shadow-md focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
				href="#main-content"
			>
				Skip to content
			</a>
			<div className="flex shrink-0 items-center">
				<AppLogo />
			</div>
			<div className="hidden flex-1 items-center justify-center md:flex">
				<HeaderClient.NavLinks />
			</div>
			<div className="flex shrink-0 items-center gap-2">
				<LanguageSwitcher />
				<HeaderClient primaryLinks={PRIMARY_LINKS.filter((l) => isBillingEnabled() || l.href !== "/#pricing")} />
			</div>
		</nav>
	);
}
